export enum SignalRHubs {
    UploadFileHub,
    UploadFileProgessHub,
    ConsolidationHub,
    ConsolidationProgressHub,
    VASubmissionProgressHub
}